import { Link } from 'react-router-dom';
import styles from './HomePage.module.css';

const HomePage = () => (
  <div className={styles.container}>
    <h1>Orange Dynasty</h1>
    <nav>
      <Link to="/levels">Levels</Link>
      <Link to="/dashboard">Dashboard</Link>
      <Link to="/house">House Building</Link>
    </nav>
  </div>
);

export default HomePage;